"use client";

import { Button, Icon } from "@theme/components";
import clsx from "clsx";
import { useEffect, useState } from "react";

export const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isBrowser = () => typeof window !== 'undefined';
  const scrollToTop = () => {
      if (!isBrowser()) return;
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Button
      className={clsx([
        "bg-primary-black size-10 rounded-full flex items-center justify-center fixed bottom-[calc(1.25rem+var(--sticky-cta-height,0px))] right-5 cursor-pointer p-0 invisible transform transition-all z-[4]",
        isVisible && "visible"
      ])}
      appearance="ghost"
      onClick={scrollToTop}
    >
      <Icon name="chevron-up" size={20} className="text-white" />
    </Button>
  );
}
